export default {
  production: {
    // TODO: Update production info
    clientId: '0oalw4lgrsUBQk2yG5d7',
    issuer: 'https://login.guesty.com/oauth2/auslw4kic6gLU6ZL85d7',
    googleIDPId: '0oalw4p0sz8mMX3F65d7',
  },
  staging5: {
    clientId: '0oateqsst9bMhrWsf697',
    issuer: 'https://login-staging5.guesty.com/oauth2/austeqyapawKbepQ6697',
    googleIDPId: '0oater0nw14j2B0fi697',
  },
};
